module.exports = __webpack_public_path__ + "media/images/slider_h1_sp_01-1626dbb881a8829893f409690bbeb590.png";